import { combineReducers } from 'redux'
import AuthReducer from './AuthReducer'
import FiltrosReducer from './FiltrosReducer'
import PesqReducer from './PesqReducer'
import DadosReducer from './DadosReducer'

export default combineReducers({
    auth: AuthReducer,
    pesq: PesqReducer,
    dados: DadosReducer
})

//export default AuthReducer